var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5757 16.4243C15.8101 16.6586 16.1899 16.6586 16.4243 16.4243C16.6586 16.19 16.6586 15.8101 16.4243 15.5757L15.5757 16.4243ZM12.7213 11.8728C12.487 11.6385 12.1071 11.6385 11.8728 11.8728C11.6385 12.1071 11.6385 12.487 11.8728 12.7213L12.7213 11.8728ZM7.61765 13.6353C4.29419 13.6353 1.6 10.9411 1.6 7.61765H0.4C0.4 11.6038 3.63145 14.8353 7.61765 14.8353V13.6353ZM1.6 7.61765C1.6 4.29419 4.29419 1.6 7.61765 1.6V0.4C3.63145 0.4 0.4 3.63145 0.4 7.61765H1.6ZM7.61765 1.6C10.9411 1.6 13.6353 4.29419 13.6353 7.61765H14.8353C14.8353 3.63145 11.6038 0.4 7.61765 0.4V1.6ZM13.6353 7.61765C13.6353 10.9411 10.9411 13.6353 7.61765 13.6353V14.8353C11.6038 14.8353 14.8353 11.6038 14.8353 7.61765H13.6353ZM16.4243 15.5757L12.7213 11.8728L11.8728 12.7213L15.5757 16.4243L16.4243 15.5757Z",
    fill: "#2AB7F8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.927a96a21c69ef2165fe67f4b3793e84.svg";
export { ForwardRef as ReactComponent };